import { combineReducers } from "redux";
import Layout from "./layout/reducer";

const rootReducer = combineReducers({
  Layout,
});

export default rootReducer;